export default {
      id: "icon-arrow-long-left-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-arrow-long-left",
      toString: function () {
        return this.url;
      }
    }